import ShapeIcon from '@/assets/logo/logo-symbol-color.svg';

const DShapeLogo = ({ className }) => {
  return <img src={ShapeIcon} className={className} />;
};

export default DShapeLogo;
